//https://5zv94oiic8.execute-api.us-west-1.amazonaws.com/production/api/locate
import geoLocator from "./geo-locator";

class AnalyticsTracking {
  constructor() {}

  addToDataLayer(args) {
    window.dataLayer.push(args);
  }

  dispatchTrackingEvent = (eventName, detail = undefined, domEvent) => {
    const trackingEvent = new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      detail: detail,
    });

    const dispatchingElement =
      domEvent && domEvent.target ? domEvent.target : document;
    dispatchingElement.dispatchEvent(trackingEvent);
  };

  sendEvent(
    eventCategory = null,
    eventAction = null,
    eventLabel = null,
    eventValue = null,
    eventNonInteraction = false,
    fieldsObject = null
  ) {
    eventValue = eventValue || 1;

    let params = {
      event: "GAevent",
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue,
      eventNonInteraction: eventNonInteraction,
    };
    params = Object.assign({}, params, fieldsObject);
    window.dataLayer.push(params);
  }

  registerGlobalLinkTrack() {
    let links = document.querySelectorAll("[data-track-click]");
    Array.from(links).forEach(
      function (link) {
        link.addEventListener(
          "click",
          function (event) {
            const eventCategory = event.currentTarget.getAttribute(
              "data-track-category"
            );
            const eventLabel =
              event.currentTarget.getAttribute("data-track-label");
            const eventValue =
              event.currentTarget.getAttribute("data-track-value") ||
              event.currentTarget.getAttribute("href");
            const nonInteraction =
              event.target.getAttribute("data-track-non-interaction") == "true";
            this.sendEvent(
              eventCategory,
              "click",
              eventLabel,
              eventValue,
              nonInteraction
            );
          }.bind(this),
          false
        );
      }.bind(this)
    );
  }

  registerRelatedCruisesLinkTrack() {
    let links = document.querySelectorAll(".related_cruises_aside a");
    Array.from(links).forEach(
      function (link) {
        link.addEventListener(
          "click",
          function (event) {
            const eventCategory = "Related Cruises";
            const eventLabel =
              event.currentTarget.getAttribute("data-track-label");
            const eventValue = event.currentTarget.getAttribute("href");
            const nonInteraction = true;
            this.sendEvent(
              eventCategory,
              "click",
              eventLabel,
              eventValue,
              nonInteraction
            );
          }.bind(this),
          false
        );
      }.bind(this)
    );
  }

  registerDomEvents() {
    this.registerGlobalLinkTrack();
    this.registerRelatedCruisesLinkTrack();
  }

  notifyMotomo(action, form) {
    if (typeof window._paq !== "undefined") {
      window._paq.push([`FormAnalytics::${action}`, form]);
    }
  }
}
export default new AnalyticsTracking();
